var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Bag",
    d: "M48.947,60H11.053A11.064,11.064,0,0,1,0,48.949l4.287-37.9A11.063,11.063,0,0,1,15.337,0H44.663A11.062,11.062,0,0,1,55.711,11.051L60,48.949A11.064,11.064,0,0,1,48.947,60Zm-30-47.434a4.526,4.526,0,0,0-3.873,2.262,4.438,4.438,0,0,0-.036,4.456,17.15,17.15,0,0,0,29.914,0,4.441,4.441,0,0,0-.038-4.458,4.524,4.524,0,0,0-3.871-2.261,4.651,4.651,0,0,0-1.127.141l-1.8.448a33.516,33.516,0,0,1-8.126,1,33.516,33.516,0,0,1-8.126-1l-1.8-.448A4.651,4.651,0,0,0,18.952,12.566Z",
    fill: "#45434D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.58b40470.svg";
export { ForwardRef as ReactComponent };